import moment from "moment";
import type * as Scrivito from "scrivito";

import { createMultiselectComponent } from "utils";
import {
  categoryClients,
  categoryOwners,
  categoryLanguages,
} from "./_defaultPageAttributes";

export const defaultPageEditingConfigAttributes = {
  title: {
    title: "Title",
    description: "Limit to 55 characters.",
  },
  showConfiguratorNav: {
    title: "Show configurator nav",
    description: "Nav with configurator navigation",
  },
  isJSSiteReady: {
    title: "Is JS Site ready?",
    description:
      "If yes, then all links which navigate to this page will show JS version of it. If no, then links will navigate to Ruby app",
  },
  categoryClients: {
    title: "Category client",
  },
  categoryLanguages: {
    title: "Category languages",
  },
  categoryOwners: {
    title: "Category owner",
  },
  publishFrom: {
    title: "Publish from",
  },
  publishUntil: {
    title: "Publish until",
  },
};

export const defaultPageInitialContent = {
  publishFrom: moment().startOf("day").toDate(),
  publishUntil: null,
  isJSSiteReady: true,
  showConfiguratorNav: false,
  categoryClients: ["DE"],
  categoryLanguages: ["de"],
  categoryOwner: ["DE"],
};

export const defaultPageProperties = [
  "title",
  "subtitle",
  "showConfiguratorNav",
  "isJSSiteReady",
  "publishFrom",
  "publishUntil",
];

export const defaultPropertiesGroups = [
  {
    title: "Language categories",
    component: createMultiselectComponent([
      {
        title: "Category clients",
        attribute: "categoryClients",
        values: categoryClients,
      },
      {
        title: "Category languages",
        attribute: "categoryLanguages",
        values: categoryLanguages,
      },
      {
        title: "Category owner",
        attribute: "categoryOwner",
        values: categoryOwners,
      },
    ]),
    properties: ["categoryClients", "categoryLanguages", "categoryOwner"],
  },
];

export const defaultPageValidations = [
  [
    "title",
    (title: string) => {
      if (title.length === 0) {
        return {
          message: "The title should be set.",
          severity: "warning" as const,
        };
      }
    },
  ],
  [
    "body", // TODO: we'll be able to get rid of this validator, when content from Ruby app will be replaced by widgetlist (no HTML injections)
    (body: string) => {
      if (body.includes("<img") || body.includes("background-image")) {
        return {
          message:
            "Please, avoid images injection as a poor HTML use ImageWidget or similar instead",
          severity: "warning" as const,
        };
      }
    },
  ],
  [
    "categoryClients",
    (category: string) => {
      if (!category.length) {
        return {
          message: "The category clients should be set.",
          severity: "warning" as const,
        };
      }
    },
  ],
  [
    "categoryLanguages",
    (category: string) => {
      if (!category.length) {
        return {
          message: "The category languages should be set.",
          severity: "warning" as const,
        };
      }
    },
  ],
  [
    "categoryOwner",
    (category: string) => {
      if (!category.length) {
        return {
          message: "The category owners should be set.",
          severity: "warning" as const,
        };
      }
    },
  ],
  (obj: Scrivito.Obj) => {
    const widgetsBodiesWarns: { message: string }[] = [];
    // TODO: we'll be able to get rid of this validator, when content from Ruby app will be replaced by widgetlist (no HTML injections)
    obj.widgets().forEach((w: Scrivito.Widget) => {
      const body = w.get("body");
      if (
        typeof body === "string" &&
        (body.includes("<img") || body.includes("background-image"))
      ) {
        widgetsBodiesWarns.push({
          message: `Please, use ImageWidget or similar at ${w.objClass()} with ${
            w.get("title") || "EMPTY"
          } title`,
        });
      }
    });

    if (widgetsBodiesWarns.length !== 0) {
      return {
        message: widgetsBodiesWarns
          .map((warning) => warning.message)
          .join("\r\n"),
        severity: "warning" as const,
      };
    }
  },
] as const;
